var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM15.5355 8.46449C15.926 8.85502 15.926 9.48818 15.5355 9.87871L13.4142 12L15.5356 14.1213C15.9261 14.5119 15.9261 15.145 15.5356 15.5356C15.1451 15.9261 14.5119 15.9261 14.1214 15.5356L12 13.4142L9.87861 15.5356C9.48808 15.9261 8.85492 15.9261 8.46439 15.5356C8.07387 15.145 8.07387 14.5119 8.46439 14.1213L10.5858 12L8.46454 9.87871C8.07402 9.48818 8.07402 8.85502 8.46454 8.46449C8.85506 8.07397 9.48823 8.07397 9.87875 8.46449L12 10.5857L14.1212 8.46449C14.5118 8.07397 15.1449 8.07397 15.5355 8.46449Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.fba2ce143215463fe1fac4b7a158212e.svg";
export { ForwardRef as ReactComponent };